import FnrFetch3 from "Utilities/FnrFetch/FnrFetch3";
import { fnThrowError } from "Utilities/fnReportError";

export const getPrayerRequests = async ({ nextPageCursor = "" }) => {
  const endpoint = `/prayerRequests?nextPageCursor=${nextPageCursor}`;

  const fetchFunction = new FnrFetch3(endpoint);

  const response = await fetchFunction.get().catch((err) => {
    const error = new Error();
    error.message = err?.message || `Error at ${endpoint}: ${err}`;
    error.error = err?.error || "error";
    throw error;
  });

  return response;
};

export const getPrayerRequestMetadata = async () => {
  const endpoint = `/prayerRequests/metadata`;

  const fetchFunction = new FnrFetch3(endpoint);

  const response = await fetchFunction.get().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err.message || err}`,
    })
  );

  return response;
};

export const getPrayerRequestStats = async () => {
  const endpoint = `/prayerRequests/stats`;

  const fetchFunction = new FnrFetch3(endpoint);

  const response = await fetchFunction.get().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err.message || err}`,
    })
  );

  return response;
};

export const markPostAsSeen = async (postData) => {
  const endpoint = `/prayerRequests/markAsSeen`;
  const fetchFunction = new FnrFetch3(endpoint, postData);

  const response = await fetchFunction.post().catch((err) => {
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    });
  });

  return response;
};

export const reactToPrayerRequest = async (postData) => {
  const endpoint = `/prayerRequests/react`;
  const fetchFunction = new FnrFetch3(endpoint, postData);

  const response = await fetchFunction.post().catch((err) => {
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    });
  });

  return response;
};

export const deletePrayerRequest = async (postData) => {
  const endpoint = `/prayerRequests/delete/${postData}`;
  const fetchFunction = new FnrFetch3(endpoint);

  const response = await fetchFunction.post().catch((err) => {
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    });
  });

  return response;
};

export const deletePrayerRequestReaction = async (postData) => {
  const endpoint = `/prayerRequests/deleteReaction`;
  const fetchFunction = new FnrFetch3(endpoint, postData);

  const response = await fetchFunction.post().catch((err) => {
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    });
  });

  return response;
};

export const createPrayerRequest = async ({ message }) => {
  const endpoint = `/network/prayerRequest`;

  const fetchFunction = new FnrFetch3(endpoint, {
    message,
  });
  const response = await fetchFunction.post(endpoint).catch((err) => {
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    });
  });

  return response;
};

export const updateNetworkSetting = async ({ settingName, value }) => {
  const endpoint = `/network/updateSetting`;
  const fetchFunction = new FnrFetch3(endpoint, {
    settingName,
    value,
  });

  const response = await fetchFunction.post().catch((err) => {
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    });
  });

  return response;
};

export const editNetworkPreferences = async ({
  userID,
  preferenceKey,
  preferenceValue,
}) => {
  const endpoint = `/user/${userID}/editNetworkPreferences`;
  const formData = new FormData();
  formData.append(preferenceKey, preferenceValue);

  const fetchFunction = new FnrFetch3(endpoint, formData);

  const response = await fetchFunction.post().catch((err) => {
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    });
  });

  return response;
};
